import React from "react";
import Social from "./Social";
import Header from "./Header";
import Footer from "./Footer";
import NewsText from "./NewsText";
import AdFoxTGB1 from "./AdFoxTGB1";
import AdFoxTGB3_2 from "./AdFoxTGB3";
import AdFoxTGB3_1 from "./AdFoxTGB3_1";
import AdFoxTGB6 from "./AdFoxTGB6";
import YandexRec from "./YandexRecWidget"
import SmiJs from "./SmiJs"
import * as fixed from "../utils/fixedBlock";
export default class Template900Component extends React.Component {
    componentDidMount() {
        document.body.classList = "is-constructor red-theme";
        import("./js/app.js").then(() => {
            console.log("template900js load done");

            fixed.connect({
                block: $(".sb-wrapper"),
                beforeTop: $("#main-content"),
                untilBottom: $("#main-content")
            });

            fixed.connect({
                block: $(".social-desktop"),
                beforeTop: $("#main-content"),
                untilBottom: $("#main-content")
            });
        });
    }

    render() {
        const { data, scrollData, categories, news, context, onTeaserClick, scrollLoading } = this.props;

        return (
            <div className="out">
                <SmiJs />
                <div className="out__inner">
                    <Header categories={categories} />
                    <div className="inner inner-sm">
                        <div className="constructor">
                            <div className="constructor__wrap">
                                <div className="constructor__soc mobile-hide" />
                                <div className="constructor__sidebar tablet-hide" />
                            </div>
                            <div className="constructor__wrap" id="main-content">
                                <Social news={news} context={context}/>
                                <main className="constructor__main">

                                    <AdFoxTGB1 context={context} />
                                    <div className="simplebanner">
                                        <div className="t900-img-wrapper">
                                            <img
                                                src={news.image.replace("/public/media/", "/public/media/680x340/")}
                                                alt={news.title}
                                            />
                                            <h1 className="t900-news-title">{news.title}</h1>
                                        </div>
                                        <div className="simplebanner__source">
                                            <div className="simplebanner__item">
                                                Источник материала:{" "}
                                                <a target="_blank" href={news.source_url}>
                                                    {news.source_title}
                                                </a>
                                            </div>
                                            <div className="simplebanner__item">
                                                <div className="simplebanner__date">Время на чтение: 5 минут</div>
                                            </div>
                                        </div>
                                    </div>
                                    <NewsText news={news} data={data} onClick={onTeaserClick} context={context} />
                                    {/* <SocialMobile news={news} /> */}
                                    {/* <ReadAlso teasers={data.bottomList} onClick={onTeaserClick} /> */}

                                    <YandexRec context={context} />
                                    <div className="constnews">
                                
                                    </div>
                                </main>

                                <aside className="constructor__sidebar tablet-hide" id="sb-right">
                                    <div className="sb-wrapper">
                                        <AdFoxTGB3_1 context={context} />
                                        <AdFoxTGB3_2 context={context} />
                                    </div>
                                </aside>
                            </div>
                        </div>
                        <AdFoxTGB6 context={context} />
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}
